import { render } from "./PromotionTexts.vue?vue&type=template&id=30335ce0&scoped=true"
import script from "./PromotionTexts.vue?vue&type=script&lang=js"
export * from "./PromotionTexts.vue?vue&type=script&lang=js"

import "./PromotionTexts.vue?vue&type=style&index=0&id=30335ce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30335ce0"]])

export default __exports__